import { createSelector } from 'reselect'

const getLoading = state => state.loading

const loading_selector = createSelector(
	[ getLoading ],
	loading => ({
		animation: loading.animation,
		show: loading.showLoading,
		text: loading.text,
		isTransparent: loading.isTransparent,
	})
)

export default loading_selector
